export default "__VITE_ASSET__BDiX3DmT__"